export const flagMapping: Record<string, string> = {
  af: '139-afghanistan.svg',
  al: '144-albania.svg',
  dz: '135-Algeria.svg',
  as: '176-american samoa.svg',
  ad: '159-andorra.svg',
  ao: '137-angola.svg',
  ai: '174-anguilla.svg',
  ag: '157-antigua and barbuda.svg',
  ar: '198-argentina.svg',
  am: '140-armenia.svg',
  aw: '162-aruba.svg',
  au: '142-australia.svg',
  at: '072-austria.svg',
  az: '136-azerbaijan.svg',
  bs: '067-bahamas.svg',
  bh: '145-bahrain.svg',
  bd: '133-bangladesh.svg',
  bb: '150-barbados.svg',
  by: '151-belarus.svg',
  be: '208-belgium.svg',
  bz: '146-belize.svg',
  bj: '163-benin.svg',
  bm: '147-bermuda.svg',
  bt: '167-bhutan.svg',
  bo: '128-bolivia.svg',
  ba: '148-bosnia and herzegovina.svg',
  bw: '134-botswana.svg',
  br: '022-brazil.svg',
  bn: '154-brunei.svg',
  bg: '126-bulgaria.svg',
  bf: '143-burkina faso.svg',
  bi: '158-burundi.svg',
  kh: '129-cambodia.svg',
  cm: '155-cameroon.svg',
  ca: '066-canada.svg',
  cv: '165-cape verde.svg',
  ky: '169-cayman islands.svg',
  cf: '170-central african republic.svg',
  td: '166-chad.svg',
  cl: '211-chile.svg',
  cn: '011-china.svg',
  co: '200-colombia.svg',
  km: '171-comoros.svg',
  cg: '021-republic of the congo.svg',
  cd: '003-democratic republic of congo.svg',
  cr: '130-costa rica.svg',
  ci: '016-ivory coast.svg',
  hr: '127-croatia.svg',
  cu: '132-cuba.svg',
  cy: '232-cyprus.svg',
  cz: '201-czech republic.svg',
  dk: '190-denmark.svg',
  dj: '050-djibouti.svg',
  dm: '114-dominica.svg',
  do: '244-dominican republic.svg',
  ec: '213-ecuador.svg',
  eg: '183-egypt.svg',
  sv: '247-el salvador.svg',
  gq: '020-equatorial guinea.svg',
  er: '051-eritrea.svg',
  ee: '004-estonia.svg',
  et: '261-ethiopia.svg',
  fj: '116-fiji.svg',
  fi: '210-finland.svg',
  fr: '196-france.svg',
  ga: '075-gabon.svg',
  gm: '102-gambia.svg',
  ge: '005-georgia.svg',
  de: '207-germany.svg',
  gh: '006-ghana.svg',
  gr: '191-greece.svg',
  gd: '079-grenada.svg',
  gt: '222-guatemala.svg',
  gn: '107-guinea.svg',
  gw: '052-guinea bissau.svg',
  ht: '014-haiti.svg',
  hn: '235-honduras.svg',
  hk: '195-hong kong.svg',
  hu: '209-hungary.svg',
  is: '221-iceland.svg',
  in: '055-india.svg',
  id: '184-indonesia.svg',
  ir: '199-iran.svg',
  iq: '255-iraq.svg',
  ie: '192-ireland.svg',
  il: '202-israel.svg',
  it: '262-italy.svg',
  jm: '236-jamaica.svg',
  jp: '240-japan.svg',
  jo: '220-jordan.svg',
  kz: '228-kazakhstan.svg',
  ke: '233-kenya.svg',
  ki: '082-kiribati.svg',
  kp: '225-north korea.svg',
  kr: '218-south korea.svg',
  kw: '083-kuwait.svg',
  kg: '053-kyrgyzstan.svg',
  la: '193-laos.svg',
  lv: '230-latvia.svg',
  lb: '254-lebanon.svg',
  ls: '017-lesotho.svg',
  lr: '043-liberia.svg',
  ly: '036-libya.svg',
  li: '045-liechtenstein.svg',
  lt: '237-lithuania.svg',
  lu: '239-luxembourg.svg',
  mo: '117-macao.svg',
  mk: '038-republic of macedonia.svg',
  mg: '008-madagascar.svg',
  mw: '009-malawi.svg',
  my: '206-malaysia.svg',
  mv: '029-maldives.svg',
  ml: '054-mali.svg',
  mt: '250-malta.svg',
  mh: '056-marshall island.svg',
  mq: '124-martinique.svg',
  mr: '084-mauritania.svg',
  mu: '241-mauritius.svg',
  mx: '033-mexico.svg',
  fm: '057-micronesia.svg',
  md: '030-moldova.svg',
  mc: '219-monaco.svg',
  mn: '010-mongolia.svg',
  me: '031-montenegro.svg',
  ms: '086-montserrat.svg',
  ma: '181-morocco.svg',
  mz: '256-mozambique.svg',
  mm: '234-myanmar.svg',
  na: '242-namibia.svg',
  nr: '088-nauru.svg',
  np: '012-nepal.svg',
  nl: '077-netherlands.svg',
  nz: '214-new zealand.svg',
  ni: '248-nicaragua.svg',
  ne: '058-niger.svg',
  ng: '252-nigeria.svg',
  nu: '118-niue.svg',
  nf: '059-norfolk island.svg',
  mp: '089-northern marianas islands.svg',
  no: '204-norway.svg',
  om: '260-oman.svg',
  pk: '231-pakistan.svg',
  pw: '119-palau.svg',
  ps: '091-palestine.svg',
  pa: '215-panama.svg',
  pg: '032-papua new guinea.svg',
  py: '001-paraguay.svg',
  pe: '188-peru.svg',
  ph: '186-philippines.svg',
  pl: '164-poland.svg',
  pt: '097-portugal.svg',
  pr: '257-puerto rico.svg',
  qa: '243-qatar.svg',
  ro: '212-romania.svg',
  ru: '044-russia.svg',
  rw: '018-rwanda.svg',
  kn: '094-saint kitts and nevis.svg',
  lc: '122-st lucia.svg',
  vc: '101-st vincent and the grenadines.svg',
  ws: '013-samoa.svg',
  sm: '047-san marino.svg',
  st: '060-sao tome and principe.svg',
  sa: '203-saudi arabia.svg',
  sn: '002-senegal.svg',
  rs: '227-serbia.svg',
  sc: '111-seychelles.svg',
  sl: '112-sierra leone.svg',
  sg: '131-singapore.svg',
  sk: '217-slovakia.svg',
  si: '258-slovenia.svg',
  sb: '098-solomon islands.svg',
  so: '063-somalia.svg',
  za: '187-south africa.svg',
  ss: '100-south sudan.svg',
  es: '229-spain.svg',
  lk: '023-sri lanka.svg',
  sd: '040-sudan.svg',
  sr: '064-suriname.svg',
  sz: '024-swaziland.svg',
  se: '189-sweden.svg',
  ch: '175-switzerland.svg',
  sy: '223-syria.svg',
  tw: '182-taiwan.svg',
  tj: '025-tajikistan.svg',
  tz: '259-tanzania.svg',
  th: '087-thailand.svg',
  tl: '035-East Timor.svg',
  tg: '068-togo.svg',
  tk: '103-tokelau.svg',
  to: '123-tonga.svg',
  tt: '026-trinidad and tobago.svg',
  tn: '249-tunisia.svg',
  tr: '153-turkey.svg',
  tm: '069-turkmenistan.svg',
  tc: '105-turks and caicos.svg',
  tv: '070-tubalu.svg',
  ug: '253-uganda.svg',
  ua: '197-ukraine.svg',
  ae: '194-united arab emirates.svg',
  gb: '109-united kingdom.svg',
  us: '185-united states of america.svg',
  uy: '224-uruguay.svg',
  uz: '041-uzbekistán.svg',
  vu: '113-vanuatu.svg',
  ve: '205-venezuela.svg',
  vn: '108-vietnam.svg',
  vg: '149-british virgin islands.svg',
  vi: '073-virgin islands.svg',
  ye: '042-yemen.svg',
  zm: '246-zambia.svg',
  zw: '019-zimbabwe.svg',
};
